import { render, staticRenderFns } from "./antenatal.vue?vue&type=template&id=2368ab30"
import script from "./antenatal.vue?vue&type=script&lang=js"
export * from "./antenatal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports